import { render, staticRenderFns } from "./CoTable.vue?vue&type=template&id=da1b249a&scoped=true&"
import script from "./CoTable.vue?vue&type=script&lang=ts&"
export * from "./CoTable.vue?vue&type=script&lang=ts&"
import style0 from "./CoTable.vue?vue&type=style&index=0&id=da1b249a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1b249a",
  null
  
)

export default component.exports